import { render, staticRenderFns } from "./ModalSuporte.vue?vue&type=template&id=57c2a662&"
import script from "./ModalSuporte.vue?vue&type=script&lang=js&"
export * from "./ModalSuporte.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuporte.vue?vue&type=style&index=0&id=57c2a662&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports